import styled from '@emotion/styled';

export const Styles = styled.div`
  .notes {
    .border {
      border-left-width: 1px;
    }
    &:last-child {
      .border {
        border: 0;
      }
    }
  }
`;
